import { useMemo } from 'react'

import { CompletedIcon } from './icons/CompletedIcon'
import { NotApplicableIcon } from './icons/NotApplicableIcon'
import { NotStartedIcon } from './icons/NotStartedIcon'
import { PiePercantageIcon } from './icons/PiePercantageIcon'
import { IIconProps } from './IIconProps'

interface IProgramTypeIconProps extends IIconProps {
  completeness: number
}

export const CompletenessIcon = ({
  completeness,
  width,
  height,
  viewBox,
}: IProgramTypeIconProps) => {
  const percent = useMemo(() => (completeness || 0) * 100, [completeness])

  if (completeness === -1) {
    return <NotApplicableIcon height={height} width={width} viewBox={viewBox} />
  } else if (completeness === 0) {
    return <NotStartedIcon height={height} width={width} viewBox={viewBox} />
  } else if (completeness < 1) {
    return <PiePercantageIcon height={height} width={width} viewBox={viewBox} percent={percent} />
  } else {
    return <CompletedIcon height={height} width={width} viewBox={viewBox} />
  }
}
